import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-629815d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/Logo_Foodticket_Icon.svg",
  alt: "foodticket-logo"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusPanel = _resolveComponent("StatusPanel")!

  return (_openBlock(), _createElementBlock("div", {
    class: "logo",
    ref: "logo",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)), ["stop"]))
  }, [
    _hoisted_1,
    (_ctx.showStatusPanel)
      ? (_openBlock(), _createBlock(_component_StatusPanel, {
          key: 0,
          onCloseStatusPanel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showStatusPanel = false))
        }))
      : _createCommentVNode("", true)
  ], 512))
}